import React, { useEffect, useState } from "react";
import { Button } from "semantic-ui-react";
import { Wizard, Form, PageLoader } from "@redriver/cinnamon";
import { getRepInfo, updateForm } from "./actions";
import {
  getRepLoading,
  getCurrentStepKey,
  getSteps,
  getRepFormData,
  getIsSubmitted,
  getIsConfirmed,
} from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import ProgressSteps from "./ProgressSteps";
import FormStep from "./FormStep";

const EditRepDetails = () => {
  const dispatch = useDispatch();
  const loading = useSelector(getRepLoading);
  const currentStepKey = useSelector(getCurrentStepKey);
  const steps = useSelector(getSteps);
  const formData = useSelector(getRepFormData);
  const isConfirmed = useSelector(getIsConfirmed);

  useEffect(() => {
    dispatch(getRepInfo());
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="rep-details">
      <Form
        value={formData}
        onChange={(field, data, applyChanges) =>
          dispatch(updateForm({ applyChanges }))
        }
      >
        <Wizard
          steps={steps}
          step={currentStepKey != null ? currentStepKey : steps[0].key}
        >
          <Wizard.Nav component={ProgressSteps} />
          {steps.map((x) => (
            <Wizard.Step
              key={x.key}
              step={x.key}
              render={(stepProps) => <FormStep {...stepProps} steps={steps} />}
            />
          ))}
        </Wizard>
      </Form>
    </div>
  );
};

export default EditRepDetails;
